import EventEmitter from 'eventemitter3';

export const activeSpeakerEmitter = new EventEmitter();
export const unreadMessageEmitter = new EventEmitter();